import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { ServicesSection } from '../components/ServicesSection';
import { StorySection } from '../components/StorySection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen bg-cream flex flex-col font-sans" data-id="element-252">
      <Navbar data-id="element-253" />
      <main className="flex-grow" data-id="element-254">
        <HeroSection data-id="element-255" />
        <ServicesSection data-id="element-256" />
        <StorySection data-id="element-257" />
        <TestimonialsSection data-id="element-258" />
        <CTASection data-id="element-259" />
      </main>
      <Footer data-id="element-260" />
    </div>;
}